
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/account/support",
      function () {
        return require("private-next-pages/d/account/support.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/account/support"])
      });
    }
  